const TASK_TYPES = {
  AUTOMATED_TESTING: 1,
  EXPERT_REVIEW: 2,
};

const TASK_FORMATS = {
  OFFLINE: 0,
  ONLINE: 1,
};

const TASK_QUESTIONS_TYPES = {
  MANUALLY: 0,
  UPLOADING_FILE: 1,
};

const TASK_STATUSES = {
  DRAFT: 1,
  PUBLISHED: 2,
  DELETED: 3,
};

const TASK_CREATORS = {
  HIGH_LEVEL_ORGANIZATION: 0,
  OWNER: 1,
};

const TASK_MEMBER_STATUS = {
  NO_FINISHED: 1,
  NO_VERIFIED: 2,
  COMPLETED: 3,
};

export default {
  TASK_TYPES,
  TASK_FORMATS,
  TASK_STATUSES,
  TASK_CREATORS,
  TASK_QUESTIONS_TYPES,
  TASK_MEMBER_STATUS,
};
